export enum AppType {
  TPL = '3PL',
  CAPTAIN = 'Captain',
  CHARITY = 'Charity',
  TAX_RECEIPT = 'TaxReceipt',
  ZENDESK = 'Zendesk',
  DRIVER = 'Driver',
  DONOR = 'Donor'
}
